import { render } from "./NotFoundView.vue?vue&type=template&id=36aad79f"
import script from "./NotFoundView.vue?vue&type=script&lang=js"
export * from "./NotFoundView.vue?vue&type=script&lang=js"
script.render = render

export default script